import React from 'react';
import { ErrorBoundary, renderDefaultError } from './ErrorBoundary';

import './CenterLayout.sass';

type CenterLayoutProps = {
  width?: string;
  children: React.ReactNode;
};

export const CenterLayout: React.FC<CenterLayoutProps> = ({ width, children }) => (
  <div className='dmx-centerLayout'>
    <main
      className='dmx-centerLayout--inner'
      style={{
        width: width,
      }}
    >
      <ErrorBoundary fallback={renderDefaultError}>{children}</ErrorBoundary>
    </main>
  </div>
);
